export default {
	CONVERSION: {
		UPDATE:  'conversion/update'
	}
}